import {useEffect} from "react";
// eslint-disable-next-line
const useOnmount = (func) => useEffect(func, [])
export default useOnmount
